module.exports = __webpack_public_path__ + "static/taiwan-tourism-4cb80e521ff2449124dd2202864c8111.svg";